import { render, staticRenderFns } from "./UserSubscriptionPlans.vue?vue&type=template&id=ec20da0c&scoped=true&"
import script from "./UserSubscriptionPlans.vue?vue&type=script&lang=js&"
export * from "./UserSubscriptionPlans.vue?vue&type=script&lang=js&"
import style0 from "./UserSubscriptionPlans.vue?vue&type=style&index=0&id=ec20da0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec20da0c",
  null
  
)

export default component.exports